import React from 'react';
import { Box, Typography } from '@mui/material';

const EmptyStateMessage = ({ title, subtitle }) => {
    return (
        <Box
            sx={{
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <Box sx={{ px: 4, py: 3, textAlign: 'center' }}>
                <Typography variant="h5" gutterBottom>
                    {title}
                </Typography>
                {subtitle && (
                    <Typography variant="body1" color="text.secondary">
                        {subtitle}
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default EmptyStateMessage;
